export default "__VITE_ASSET__ml$4O5Ix__"